import { useModuleDetails } from "modules/moduleTemplates/components/ModuleDetailsDrawer/context";
import { useGeneralData } from "modules/moduleTemplates/components/ModuleDetailsDrawer/stores/useGeneralData";
import React, { type FC } from "react";
import CardBlockForm from "./components/CardBlockForm";

const ThreeCardBlocksConfig: FC = () => {
  const { threeCardsLoadingQueries } = useModuleDetails();
  const { contentBlocks } = useGeneralData();

  if (!contentBlocks || !contentBlocks.length) {
    return null;
  }

  return (
    <>
      {contentBlocks.map((item, index) => (
        <CardBlockForm
          key={index}
          item={item}
          index={index}
          isLoadingFile={threeCardsLoadingQueries[index]}
        />
      ))}
    </>
  );
};

export default ThreeCardBlocksConfig;
